import {
  RailwayOrderStatus,
  SeatClass
} from '@link/china-railway/services/types';

export default {
  common: {
    colon: ': ',
    cancel: '취소',
    confirm: '확인'
  },
  date: {
    month: {
      month1: '1월',
      month2: '2월',
      month3: '3월',
      month4: '4월',
      month5: '5월',
      month6: '6월',
      month7: '7월',
      month8: '8월',
      month9: '9월',
      month10: '10월',
      month11: '11월',
      month12: '12월'
    },
    weeks: {
      sun: '일',
      mon: '월',
      tue: '화',
      wed: '수',
      thu: '목',
      fri: '금',
      sat: '토'
    }
  },
  seatClass: {
    [SeatClass.Business]: '비즈니스석',
    [SeatClass.Premium]: '특등석',
    [SeatClass.First]: '일등석',
    [SeatClass.Second]: '이등석'
  },
  confirmBooking: {
    title: '안내',
    description:
      '예약 확정 후에는 변경할 수 없습니다. 다음 정보를 확인해 주세요:',
    preOrderDescription:
      '예약 확정 후, 15일 전에 [주문 상세] 페이지에서 티켓 상태를 확인해 주세요. 이메일이나 문자로 결과가 발송되지 않습니다.',
    departTime: '출발 시간',
    trainNumber: '열차 번호',
    seatNumber: '객차/좌석 번호',
    autoAssign: '자동 배정',
    passengerName: '예약자 이름',
    ticketCount: '예약 수량',
    confirmBook: '예약 확정',
    date: '{{month}}월{{day}}일',
    orderSuccess: '예약 성공',
    orderFailed: '예약 실패, 나중에 다시 시도해 주세요'
  },
  views: {
    booking: {
      bookingId: '주문 {{id}}'
    },
    railway: {
      details: '주문 상세',
      booking: '고속철도 예약',
      ticketCount: '티켓 수',
      selectDate: '탑승 날짜 선택',
      moreTime: '더 많은 시간',
      bookTicket: '열차 예약',
      status: {
        [RailwayOrderStatus.StatusUnspecified]: '알 수 없는 상태',
        [RailwayOrderStatus.Reserved]: '예매 중, 잠시만 기다려 주세요',
        [RailwayOrderStatus.Booked]: '예매 중, 잠시만 기다려 주세요',
        [RailwayOrderStatus.Cancelling]: '취소 중',
        [RailwayOrderStatus.Cancelled]: '취소됨',
        [RailwayOrderStatus.Closed]: '잔여석 부족, 다시 예매해 주세요',
        [RailwayOrderStatus.Issuing]: '예매 중, 잠시만 기다려 주세요',
        [RailwayOrderStatus.Issued]: '예매 성공, 발권 완료',
        [RailwayOrderStatus.Used]: '사용됨'
      },
      usageDate: '사용 날짜'
    },
    trainList: {
      book: '예약',
      preBook: '사전 예약',
      noTrains: '이 시간대에는 열차가 없습니다',
      hour: '시간',
      minute: '분',
      durationFormat: '{{hours}}시간 {{minutes}}분',
      ticketsLeft: '{{count}}석 남음',
      noTickets: '티켓 매진',
      notOnSale: '미발매'
    },
    orderDetail: {
      title: '주문 상세',
      faq: '자주 묻는 질문',
      dateTimeFormat: '{{year}}년 {{month}}월 {{day}}일 {{time}}',
      travelInfo: '여행 정보',
      departureTime: '출발 시간',
      trainNumber: '열차 번호',
      seatNumber: '객차/좌석 번호',
      passengerName: '예약자 이름',
      ticketCount: '예약 수량',
      highSpeedTicket: '고속철도 티켓',
      orderId: '주문 ID',
      orderTime: '주문 완료 시간',
      rebookTicket: '다시 예매',
      preOrderStatus: '예약 완료, {{days}}일 후 판매 시작',
      saleDate: '판매 시작일',
      saleDateFormat: '{{year}}년 {{month}}월 {{day}}일',
      cancelOrder: '주문 취소',
      cancelOrderSuccess: '주문이 취소되었습니다',
      cancelOrderFailed: '주문 취소에 실패했습니다. 나중에 다시 시도해 주세요',
      cancelOrderDialog: {
        title: '주문을 취소하시겠습니까',
        content: '취소 후 다시 예매할 수 있습니다',
        confirm: '취소 확인',
        cancel: '취소하지 않음'
      }
    }
  }
};
